import jquery from 'jquery';
import './menu';
import './script';
import './headings'
import './block-advance-taxonomy-terms'
import './gallery-horizontal'
import './horizontal-accordion'